import { render } from "./GiftLinkForm.vue?vue&type=template&id=eb927e54&ts=true"
import script from "./GiftLinkForm.vue?vue&type=script&lang=ts"
export * from "./GiftLinkForm.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/clickfun/frontend/clickfun_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__